import { AnyAction, Reducer } from 'redux';

export const STORE_USER_ACCOUNTS = 'data/user-accounts-from-api';
export const STORE_USER_ACCOUNTS_PUSERNAME = 'pusername/user-accounts-from-view';
export const STORE_USER_ACCOUNTS_NICKNAME = 'nickname/user-accounts-from-view';
export const STORE_USER_ACCOUNTS_EMAIL = 'email/user-accounts-from-view';
export const STORE_USER_ACCOUNTS_MOBILE = 'mobile/user-accounts-from-view';

export interface UserAccountData {
    rowno: string;
    pusername: string;
    nickname: string;
    email: string;
    mobile: string;
}

export interface UserAccountState {
    userAccountdata: UserAccountData[];
    addpusername: string;
    addnickname: string;
    addemail: string;
    addmobile: string;
}

const initialState: UserAccountState = {
    userAccountdata: [],
    addpusername: '',
    addnickname: '',
    addemail: '',
    addmobile: ''
};

const reducer: Reducer<UserAccountState> = (state: UserAccountState = initialState, action: AnyAction): UserAccountState => {
    switch (action.type) {
        case STORE_USER_ACCOUNTS:
            return {
                ...state,
                userAccountdata: action.userAccountdata
            };
        case STORE_USER_ACCOUNTS_PUSERNAME:
            return {
                ...state,
                addpusername: action.addpusername
            };
        case STORE_USER_ACCOUNTS_NICKNAME:
            return {
                ...state,
                addnickname: action.addnickname
            };
        case STORE_USER_ACCOUNTS_EMAIL:
            return {
                ...state,
                addemail: action.addemail
            };
        case STORE_USER_ACCOUNTS_MOBILE:
            return {
                ...state,
                addmobile: action.addmobile
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/userAccount.tsx